import React from "react"
import { type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import CustomersPage from "../../../CustomersPage/components/CustomersPage.tsx"

import { lazyPage } from "../lazyPage.tsx"

const CustomerDetailPage = lazyPage(
  () => import("../../../CustomersPage/CustomerDetailPage")
)
export const customerRoutes: RouteObject[] = [
  {
    path: RoutesPaths.customers.list,
    element: (
      <PermissionGate pages={["customers"]}>
        <CustomersPage />
      </PermissionGate>
    )
  },
  {
    path: RoutesPaths.customers.view(":id"),
    element: (
      <PermissionGate
        description={"You don't have permission to view customers."}
        paths={["customers.customers.customer_view"]}
      >
        <CustomerDetailPage />
      </PermissionGate>
    )
  }
]
